module.exports = __webpack_public_path__ + "static/img/ex_t3.7e51980.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ex_t3.jpg
// module id = PxJt
// module chunks = 1